import React, { Component, Fragment } from "react";
import EmptyState from "../../common/EmptyState";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Datatable extends Component {
  render() {
    const { myData, history, startToggleModal } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="of-table-wrap">
          <table className="table of-table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Address</th>
                <th scope="col" className="of-col-action">Action</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={3} className="of-empty">
                    <EmptyState>No offices yet.</EmptyState>
                  </td>
                </tr>
              ) : (
                rows.map((office, i) => (
                  <tr key={i}>
                    <td>{office.name}</td>
                    <td>{office.address}</td>
                    <td className="of-col-action">
                      <button
                        type="button"
                        className="of-icon-btn of-icon-btn--edit"
                        onClick={() => startToggleModal(office)}
                      >
                        <i className="fa fa-pencil"></i>
                      </button>
                      <button
                        type="button"
                        className="of-icon-btn of-icon-btn--view"
                        onClick={() => {
                          history.push(`/expense/office/${office.name}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
